import PropTypes from 'prop-types'
import React from 'react'

import InfoPopup from './InfoPopup'
import { SORT_ORDERS, SORT_ORDER_DETAILS } from '../constants'

function sortOrderOptionsForSelect () {
  let sortKeys = Object.keys(SORT_ORDERS)

  return sortKeys.map((sortKey, index) => {
    return (<option value={sortKey} key={index}>{SORT_ORDERS[sortKey]}</option>)
  })
}
const ProgramSorter = (props) => {
  return (
    <React.Fragment>
      <div className='form-group mb-3'>
        <label htmlFor='sortOrder' className='' >
          <strong>Sortierung</strong>
        </label>
        <InfoPopup title='Infos zur Sortierung'
                   body={SORT_ORDER_DETAILS}
                   containerRef={props.containerRef} />
        <select name='sortOrder'
                id='sortOrder'
                value={props.order}
                className='form-select form-select-sm'
                onChange={(e) => props.onChange(e.target.value)}>
          {sortOrderOptionsForSelect()}
        </select>
      </div>
    </React.Fragment>
  )
}

ProgramSorter.propTypes = {
  order: PropTypes.oneOf(['price_ascending', 'price_descending', 'popularity']).isRequired,
  onChange: PropTypes.func.isRequired,
  containerRef: PropTypes.object.isRequired
}

export default ProgramSorter
